import { Music24PlanTier, music24PlanCapabilities } from 'fym-shared/src/music24/music24Plans';
import { STREAMING_DAY_OPTIONS, STREAMING_DEFAULT_DAYS, StreamingDays } from 'fym-shared/src/music24/streaming';

/** The period on a plan whose history is shorter than the default period (Free). */
export const STREAMING_SHORT_DAYS: StreamingDays = 7;

/** True when the value is one of the periods of the picker. */
export function isStreamingDays(value: number): value is StreamingDays {
  return (STREAMING_DAY_OPTIONS as readonly number[]).includes(value);
}

/** 28 days, or 7 days when the plan shows less than 28 days (design f6). */
export function defaultStreamingDays(historyDaysLimit: number): StreamingDays {
  return historyDaysLimit < STREAMING_DEFAULT_DAYS ? STREAMING_SHORT_DAYS : STREAMING_DEFAULT_DAYS;
}

/** True when the plan does not show this many days. The server cuts the period to the same limit. */
export function isStreamingPeriodLocked(days: number, historyDaysLimit: number): boolean {
  return days > historyDaysLimit;
}

/** The period to use: the asked value when the plan shows it, else the default of the plan. */
export function resolveStreamingDays(asked: string | null, historyDaysLimit: number): StreamingDays {
  const parsed = asked === null ? NaN : Number(asked);
  if (isStreamingDays(parsed) && !isStreamingPeriodLocked(parsed, historyDaysLimit)) {
    return parsed;
  }
  return defaultStreamingDays(historyDaysLimit);
}

// Plug costs the most ($299), so it is last: a cheaper plan with the same history always wins.
const PAID_TIERS_CHEAPEST_FIRST: readonly Music24PlanTier[] = ['artist', 'pro', 'manager', 'label', 'plug'];

/** The cheapest plan that shows this many days. The upgrade prompt names it. */
export function planForStreamingDays(days: number): Music24PlanTier {
  return PAID_TIERS_CHEAPEST_FIRST.find((tier) => music24PlanCapabilities[tier].historyDaysLimit >= days) ?? 'label';
}
